var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"Credit Note Temporary"}},[_c('vs-tabs',{model:{value:(_vm.tabs),callback:function ($$v) {_vm.tabs=$$v},expression:"tabs"}},[_c('vs-tab',{attrs:{"label":"Waiting Reversal"}},[_c('waitingRevers')],1),_c('vs-tab',{attrs:{"label":"Reversed"}},[_c('reversed')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }